<template>
  <div>
    <form id="fomrReset" class="layui-form" style="height: 100%;">
      <div class="layui-form-item">
        <label for="L_pass" class="layui-form-label">
          标段名称
        </label>
        <div class="layui-input-inline">
          {{ blockName }}
        </div>
      </div>
      <div class="layui-form-item">
        <label for="L_pass" class="layui-form-label">
          标段编号
        </label>
        <div class="layui-input-inline">
          {{ blockCode }}
        </div>
      </div>
      <div class="layui-form-item">
        <label for="L_pass" class="layui-form-label">
          投标人名称
        </label>
        <div class="layui-input-inline">
          {{ applyUser }}
        </div>
      </div>
      <div class="layui-form-item">
        <label for="L_pass" class="layui-form-label">
          开标时间
        </label>
        <div class="layui-input-inline">
          <input
            lay-verify="required"
            name="bidOpenTime"
            type="text"
            placeholder="请填写项目开标时间"
            class="layui-input"
            id="date3"
          />
        </div>
      </div>
      <div class="layui-form-item">
        <label for="L_pass" class="layui-form-label">
          企业中标状态
        </label>
        <div class="layui-input-inline">
          <select lay-verify="required" name="isWinBidding" lay-filter="status">
            <option value="">请选择企业中标状态</option>
            <option value="1">已中标</option>
            <option value="2">未中标</option>
          </select>
        </div>
      </div>

      <div class="layui-form-item bottom-btn">
        <div class="layui-input-block">
          <button type="button" class="stepbtn layui-btn formStep1">
            取消
          </button>
          <button
            type="button"
            class="layui-btn"
            lay-submit
            lay-filter="formStep2"
          >
            更新中标记录
          </button>
          <button
            id="reset"
            type="reset"
            class="stepbtn layui-hide layui-btn layui-btn-primary"
          >
            取消
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "register",
  props: {
    fullName: {
      type: ""
    },
    blockName: {
      type: ""
    },
    applyUser: {
      type: ""
    },
    blockCode: {
      type: ""
    }
  },
  data() {
    return {
      childrenMessage: ""
    };
  },
  mounted() {
    var that = this;
    layui.use(
      ["jquery", "element", "step", "form", "laydate", "layer", "table"],
      function() {
        var $ = layui.jquery,
          form = layui.form,
          step = layui.step,
          element = layui.element,
          table = layui.table,
          layer = layui.layer,
          laydate = layui.laydate;

        laydate.render({
          elem: "#date3" //指定元素
        });
        form.render();
        //监听取消
        $(".formStep1").click(function() {
          document.getElementById("reset").click();
          layer.closeAll();
        });
        //监听提交
        form.on("submit(formStep2)", function(data) {
          that.childrenMessage = data.field;
          document.getElementById("reset").click();
          that.list();
          return false;
        });
      }
    );
  },
  beforeCreate() {
    // console.group('beforeCreate 创建前状态===============》');
  },
  created() {
    // loadingInstance.close();
  },
  methods: {
    async list() {
      var that = this;
      var params = {
        applyId: that.fullName
      };
      var obj = Object.assign(that.childrenMessage, params);
      var resualt2 = await that.$http.post("/baohanOrderList/updateBid", obj);
      console.log(resualt2);
      layer.closeAll();
      parent.layui.table.reload("articleList");
    }
  }
};
</script>

<style>
.layui-form-label {
  width: 87px;
}
.layui-input-inline {
  width: 382px !important;
  line-height: 40px;
}
</style>
